  <app-header></app-header>

  <div class="container-fluid" style="padding-top: 70px">
    <router-outlet></router-outlet>

    <br />
    <p *ngIf="angularVersion">&nbsp;<small>Angular: {{angularVersion}}</small></p>
  </div>
